import React from 'react';
import { Globe } from 'lucide-react';
import { rolleFarbe, rolleKurz, rolleLabel, statusLabel } from '../../services/talentpool/talentpoolLogik';
import type { TalentStatus } from '../../services/talentpool/talentpoolTypes';

/** Chips wie im Material-Bereich (MaterialChips) und in der Druckliste des Plotters. */
const CHIP = 'inline-flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap';

const STATUS_TON: Record<TalentStatus, string> = {
    neu: 'bg-blue-100 text-blue-700',
    kontaktiert: 'bg-sky-100 text-sky-700',
    gespraech: 'bg-amber-100 text-amber-800',
    pool: 'bg-teal-100 text-teal-700',
    zusage: 'bg-emerald-100 text-emerald-700',
    absage: 'bg-slate-200 text-slate-600',
};

export const StatusChip: React.FC<{ status: TalentStatus }> = ({ status }) => (
    <span className={`${CHIP} ${STATUS_TON[status]}`}>{statusLabel(status)}</span>
);

/** Rolle mit dem Farbpunkt der Kartennadel. `lang` zeigt den vollen Titel. */
export const RolleChip: React.FC<{ rolle: string; lang?: boolean }> = ({ rolle, lang = false }) => (
    <span className={`${CHIP} bg-slate-100 text-slate-700`} title={rolleLabel(rolle)}>
        <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: rolleFarbe(rolle) }} aria-hidden />
        {lang ? rolleLabel(rolle) : rolleKurz(rolle)}
    </span>
);

/** „Bundesweit“ hat auf der Karte keinen Ring, sondern dieses Abzeichen. */
export const BundesweitChip: React.FC = () => (
    <span className={`${CHIP} bg-indigo-50 text-indigo-700 border border-indigo-100`}>
        <Globe className="w-3 h-3" aria-hidden /> bundesweit
    </span>
);
